module.exports = __webpack_public_path__ + "static/media/carousel-body-one-image.4c820dba.png";